import React, { useState } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

const Checkbox = props => {
  const {
    className,
    disabled,
    label,
    model,
  } = props;

  let MODEL = useState(false);
  if (model) MODEL = model;
  const [checkValue, setCheckValue] = MODEL;

  const toggleCheckbox = () => {
    if (disabled) return;

    setCheckValue(!checkValue);
  }
  
  return (
    <div className={`
      ${classNames({
        'cursor-pointer': !disabled,
        'cursor-default': disabled,
      })}
      ${className}
      inline-flex
    `} onClick={toggleCheckbox}>
      <div>
        <div className={`
          bg-white h-5 w-5 border border-grey-200 rounded-md justify-center items-center relative flex
          ${classNames({
            'bg-grey-200' : disabled
          })}
        `}>
          {
            checkValue ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-grey-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 13l4 4L19 7" />
              </svg>
            ) : null
          }
        </div>
      </div>
      {
        label ? (
          <p className="ml-2 font-medium text-sm text-grey-600">{ label }</p>
        ) : null
      }
    </div>
  )
}

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  model: PropTypes.array,
}

Checkbox.defaultProps = {
  disabled: false,
  className: '',
  label: '',
  model: undefined
}

export default Checkbox;